import { MBV2NutritionSummary } from '@/models';
import { AnalyticsMeal, AnalyticsMealType } from '../platforms/adobe-analytics/models';

export class NutritionCalculatorAddToBagEvent {
  name = 'NutritionCalculatorAddToBagEvent';

  constructor(
    public readonly meal: AnalyticsMeal,
    public readonly mealType: AnalyticsMealType,
    public readonly isOrderStart: boolean,
    public readonly nutrition?: MBV2NutritionSummary,
    public readonly isPceAddToBag?: boolean
  ) { }
}
